import { Dispose } from './disposable';

export class ChangeNotifier extends Dispose {
	constructor() {
		super();
		this.appendDisposeCallback(() => {
			this._listeners = [];
		});
	}
	private _listeners: VoidCallback[] = [];

	readonly addListener = (listener: VoidCallback) => {
		this._listeners.push(listener);
	};

	readonly removeListener = (listener: VoidCallback) => {
		this._listeners.push(listener);
	};

	readonly notifyListeners = () => {
		this._listeners.forEach((v) => v());
	};
}
